import { useMutation, useQuery, useQueryClient } from "react-query";
import type { SetzeAuftrag } from "../../api";
import { createId, useGetApi } from "../../data";

export type AuftragFilter = {
  suche?: string;
  kunde?: string;
  servoTypId?: string;
  testSzenarioId?: string;
  testSzenarioVersionId?: string;
};

export function useAuftrag(id: string) {
  const getApi = useGetApi();

  return useQuery(["auftraege", id], async () =>
    (await getApi()).auftrag.getAuftrag(id)
  ).data!;
}

export function useSetzeAuftrag() {
  const getApi = useGetApi();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, daten }: { id?: string; daten: SetzeAuftrag }) =>
      (await getApi()).auftrag.setzeAuftrag(id ?? createId(), daten),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries("auftraege");
      },
    }
  );
}
